document.addEventListener('DOMContentLoaded', () => {
  new QRCode(document.getElementById('qr-code'), {
    text: `${window.location.host}${window.location.pathname}`,
    width: 102,
    height: 102
  });

  const checkboxContainers = document.querySelectorAll('.article-checklist__step, .accordion-checklist__item');
  checkboxContainers.forEach(item => {
    item.addEventListener('click', function () {
      const checkbox = item.querySelector('.checklist__item-checkbox');
      checkbox.checked = !checkbox.checked;
    });
  });

  const videoLink = document.querySelector('[data-video-link]');
  const video = document.querySelector('.embedded-video');

  if (video && videoLink) {
    videoLink.addEventListener('click', () => video.scrollIntoView({ behavior: 'smooth', block: 'center' }));
  }
});

class AccordionChecklist extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
  }

  connectedCallback() {
    this.dom = {
      button: this.querySelector('button'),
      panel: this.querySelector('.accordion-checklist__panel'),
    };

    this.addEventListeners();
    this.toggle();
  }

  addEventListeners() {
    this.dom.button.addEventListener('click', this.toggle);
  }

  toggle() {
    this.dom.button.classList.toggle('accordion-checklist__accordion--open');
    this.dom.panel.style.maxHeight = this.dom.panel.style.maxHeight ? null : this.dom.panel.scrollHeight + 'px';
  }
}

if (!customElements.get('accordion-checklist')) {
  customElements.define('accordion-checklist', AccordionChecklist);
}

class KeepScreenOn extends HTMLElement {
  constructor() {
    super();
    this.wakeLock = null;
    this.toggle = this.toggle.bind(this);
    this.requestWakeLock = this.requestWakeLock.bind(this);
    this.releaseWakeLock = this.releaseWakeLock.bind(this);
  }

  connectedCallback() {
    this.dom = {
      button: this.querySelector('button'),
      toggle: this.querySelector('.keep-screen-on__trigger-toggle'),
    };

    this.addEventListeners();
  }

  addEventListeners() {
    this.dom.button.addEventListener('click', this.toggle);
  }

  async requestWakeLock() {
    try {
      this.wakeLock = await navigator.wakeLock.request('screen');
    } catch (err) {
      console.error(`${err.name}, ${err.message}`);
    }
  };

  async releaseWakeLock() {
    if (!this.wakeLock) {
      return;
    }
    try {
      await this.wakeLock.release().then(() => {
        this.wakeLock = null;
      });
    } catch (err) {
      console.error(`${err.name}, ${err.message}`);
    }
  };

  async toggle() {
    this.dom.toggle.classList.toggle('keep-screen-on__trigger-toggle--on');

    if (!this.wakeLock) {
      await this.requestWakeLock();
    } else {
      await this.releaseWakeLock();
    }
  }
}

if (!customElements.get('keep-screen-on')) {
  customElements.define('keep-screen-on', KeepScreenOn);
}

class IngredientCalculator extends HTMLElement {
  constructor() {
    super();
    this.inputChanged.bind(this);
  }

  connectedCallback() {
    this.dom = {
      input: this.querySelector('[data-servings]'),
      plusButton: this.querySelector('[data-plus-button]'),
      minusButton: this.querySelector('[data-minus-button]'),
      ingredientAmounts: document.querySelectorAll('[data-ingredient-amount]'),
      printAmount: document.querySelector('[data-print-amount]')
    };

    this.addEventListeners();
  }

  addEventListeners() {
    this.dom.plusButton.addEventListener('click', () => {
      this.dom.input.value = parseInt(this.dom.input.value) + 1;
      this.inputChanged();
    });

    this.dom.minusButton.addEventListener('click', () => {
      if (this.dom.input.value == 1) {
        return;
      }
      this.dom.input.value = parseInt(this.dom.input.value) - 1;
      this.inputChanged();
    });

    this.dom.input.addEventListener('change', () => this.inputChanged());
  }

  inputChanged() {
    if (!this.dom.input.value) {
      return;
    }

    this.dom.printAmount.textContent = `: ${this.dom.input.value}`;

    const standardServings = parseInt(this.dom.input.dataset.servings);
    const newServingsValue = parseInt(this.dom.input.value);

    const factor = newServingsValue / standardServings;

    this.dom.ingredientAmounts.forEach(amountElement => {
      const standardAmount = parseFloat(amountElement.dataset.ingredientAmount);
      const newAmount = standardAmount * factor;

      amountElement.textContent = newAmount % 1 !== 0 ? newAmount.toFixed(2) : newAmount;
    });
  }
}

if (!customElements.get('ingredient-calculator')) {
  customElements.define('ingredient-calculator', IngredientCalculator);
}

class ScrollToSection extends HTMLElement {
  constructor() {
    super();
    this.scrollToTarget.bind(this);
  }

  connectedCallback() {
    this.dom = {
      buttons: this.querySelectorAll('button'),
    };

    this.addEventListeners();
  }

  addEventListeners() {
    this.dom.buttons.forEach(button => button.addEventListener('click', () => {
      this.scrollToTarget(button.dataset.target);
    }));
  }

  scrollToTarget(target) {
    const targetEl = document.getElementById(target);
    if (!targetEl) {
      return;
    }

    targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

if (!customElements.get('scroll-to-section')) {
  customElements.define('scroll-to-section', ScrollToSection);
}
